module.exports = __webpack_public_path__ + "static/media/in_the_bag.8b32835d.gif";